// old daywise

import React, { useMemo, useState, useEffect } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import GreyTable from "../../../components/Tables/GreyTable";
import DroupdownFilterBox from "../../../components/FilterBox/DroupdownFilterBox";
import { GreyInwardDay, GreyInwardDayparty, resetGreyInwardDay, resetGreyInwardDayparty } from "../../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { Loader } from "../../../components/Loader/Loader";
import { RiArrowRightSLine, RiArrowLeftSLine } from "react-icons/ri";



import { useRef } from "react";
import { useTheme } from "../../../Themecontext/Themecontext";

export const Daywise = () => {

  const tableRef = useRef(null);
  const FinancialYear = Cookies.get("FinancialYear");

  const dispatch = useDispatch()
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { mainFilterData } = useSelector((state) => state.ClientLogin);
  const { GreyInwardDaydata, GreyInwardDaypartydata } = useSelector((state) => state.GreyDashboardSlice);


  const formatIndianNumber = (num) => {
    if (num === null || num === undefined || num === "") return "0.00";

    const number = parseFloat(num);

    if (isNaN(number)) return "0.00";

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const [view, setView] = useState("year");
  const [type, setType] = useState("inward");
  const [hoverCell, setHoverCell] = useState(null);
  const [showDetail, setShowDetail] = useState(false);


  const [selectedCell, setSelectedCell] = useState({
    date: "",
    month: "",
    value: 0,
  });

  // FIRM
  const [selectedFirm, setSelectedFirm] = useState([]);
  const [selectedFirmId, setSelectedFirmId] = useState("");

  // AC YEAR
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedYearId, setSelectedYearId] = useState("");

  // PRODUCTION
  const [selectedProduction, setSelectedProduction] = useState([]);
  const [selectedProductionId, setSelectedProductionId] = useState([]);

  const [selectedDay, setSelectedDay] = useState(null);

  const [detailTab, setDetailTab] = useState("Group");

  const [tableApiData, setTableApiData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);




  useEffect(() => {
    if (!GreyInwardDaydata) return;

    if (type === "inward") {
      setTableApiData(GreyInwardDaydata?.Data || []);
    } else if (type === "delivery") {
      setTableApiData(GreyInwardDaydata?.Data1 || []);
    } else if (type === "balance") {
      setTableApiData(GreyInwardDaydata?.Bal || []);
    }
  }, [type, GreyInwardDaydata]);

  // useEffect(() => {

  //   if (!selectedCell?.date || !selectedCell?.month) return;

  //   const monthKey = getMonthKey(selectedCell.month);

  //   const matchedRow = tableApiData.find(
  //     (x) =>
  //       String(x.InwDay).padStart(2, "0") ===
  //       String(selectedCell.date).padStart(2, "0")
  //   );

  //   setSelectedCell((prev) => ({
  //     ...prev,
  //     value: matchedRow?.[monthKey] || 0,
  //   }));

  // }, [type, tableApiData]);


  const monthKeyMap = {
    APR: "AprInwMeter",
    MAY: "MayInwMeter",
    JUN: "JunInwMeter",
    JUL: "JulInwMeter",
    AUG: "AugInwMeter",
    SEP: "SepInwMeter",
    OCT: "OctInwMeter",
    NOV: "NovInwMeter",
    DEC: "DecInwMeter",
    JAN: "JanInwMeter",
    FEB: "FebInwMeter",
    MAR: "MarInwMeter",
  };

  const months = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];

  const getMonthKey = (month) => {
    const baseKey = monthKeyMap[month];

    if (!baseKey) return "";

    if (type === "inward") return baseKey;

    if (type === "delivery") {
      return baseKey.replace("Inw", "Fin");
    }

    if (type === "balance") {
      return baseKey.replace("Inw", "Bal");
    }

    return "";
  };

  const getDay = (item, index) => {
    if (item.InwDay) return item.InwDay;

    return String(index + 1).padStart(2, "0");
  };

  const formattedYearData = useMemo(() => {
    if (!tableApiData || tableApiData.length === 0) return [];

    return tableApiData.map((item, index) => {
      let row = {
        date: `${getDay(item, index)}`,
      };

      months.forEach((month) => {
        const key = getMonthKey(month);
        row[month] = item[key] || 0;
      });

      return row;
    });
  }, [tableApiData, type]);


  const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const monthNames = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ];

  const getActiveFinancialYear = () => {
    const activeYearId = selectedYearId || FinancialYear;

    const matchedYear = mainFilterData?.AC_Year_List?.find(
      (item) => String(item.AcYearID) === String(activeYearId)
    );

    return matchedYear?.AcYear || "";
  };

  const selectedFinancialYear = getActiveFinancialYear();

  console.log("selectedFinancialYear:", selectedFinancialYear);

  let startMonth = "";
  let startYear = "";

  const [currentDate, setCurrentDate] = useState(
    new Date(startYear, startMonth, 1)
  );

  if (selectedFinancialYear && selectedFinancialYear.includes("-")) {

    const startDate = selectedFinancialYear.split("-")[0];

    if (startDate?.includes("/")) {

      const [day, monthNumber, yearNumber] = startDate.split("/");

      // Month ID
      startMonth = (parseInt(monthNumber, 10) || 1) - 1;

      startYear = parseInt(yearNumber, 10) || "";
    }
  }

  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();

  useEffect(() => {
    if (startYear !== "" && startMonth !== "") {
      setCurrentDate(new Date(startYear, startMonth, 1));
    }
  }, [selectedFinancialYear]);

  const getCurrentMonthShort = () => {
    const monthIndex = month; // 0–11
    const normalMonths = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return normalMonths[monthIndex];
  };

  const calendarDays = useMemo(() => {
    const firstDay = new Date(year, month, 1).getDay();
    const totalDays = new Date(year, month + 1, 0).getDate();
    const prevMonthDays = new Date(year, month, 0).getDate();

    const calendar = [];

    const monthShort = getCurrentMonthShort();
    const monthKey = getMonthKey(monthShort);

    for (let i = firstDay - 1; i >= 0; i--) {
      calendar.push({
        day: prevMonthDays - i,
        disabled: true,
      });
    }

    for (let d = 1; d <= totalDays; d++) {

      const item = tableApiData[d - 1];

      calendar.push({
        day: d,
        value: item?.[monthKey] || 0,
        disabled: false,
      });
    }

    while (calendar.length < 42) {
      calendar.push({
        day: calendar.length - (firstDay + totalDays) + 1,
        disabled: true,
      });
    }

    return calendar;

  }, [month, year, tableApiData, type]);



  // Firm List
  const firmOptions =
    mainFilterData?.Firm_List?.map((item) => ({
      label: item.GroupName,     // check key name (console me dekh lena)
      value: item.DashboardFirmID,
    })) || [];

  // Account Year
  const yearOptions =
    mainFilterData?.AC_Year_List?.map((item) => ({
      label: item.AcYear,   // ya item.YearName (API check kar)
      value: item.AcYearID,
    })) || [];

  // Production Group
  const productionOptions =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item.ProductionGroupMstName,
      value: item.ProductionGroupMstID,
    })) || [];



  const handlesubmit = () => {

    const financialYear = Cookies.get("FinancialYear");
    console.log(financialYear);


    dispatch(resetGreyInwardDay());

    dispatch(GreyInwardDay({
      Firm: selectedFirmId ? selectedFirmId.toString() : "",

      AcYearIDs: selectedYearId
        ? selectedYearId.toString()
        : financialYear.toString(),

      ProductionGroupMstIDs: selectedProductionId
        ? selectedProductionId.toString()
        : ""
    }));

    setIsFilterApplied(true);

    setTimeout(() => {
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 100);
  };

  const detailColumns = useMemo(() => {
    if (detailTab === "Group") {
      return [
        { label: "Sr No", key: "srNumber", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
        { label: "ProductionGroupMstName", key: "ProductionGroupMstName", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2, },
        { label: "Inward Meter", key: "InwMeter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: true },
      ];
    }

    if (detailTab === "Party") {
      return [
        { label: "Sr No", key: "srNumber", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
        { label: "Party Name", key: "AcName", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
        { label: "Inward Meter", key: "InwMeter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: true },
      ];
    }

    if (detailTab === "Quality") {
      return [
        { label: "Sr No", key: "srNumber", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
        { label: "Quality Name", key: "ItemName", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
        { label: "Inward Meter", key: "InwMeter", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5, format: true },
      ];
    }

    return [];
  }, [detailTab]);

  const formattedDetailData = useMemo(() => {
    if (!GreyInwardDaypartydata) return [];

    let data = [];

    const getMonthKeyName = (month) => {
      if (!month) return "";

      const formatted =
        month.charAt(0).toUpperCase() +
        month.slice(1).toLowerCase();

      if (type === "inward") {
        return `${formatted}InwMeter`;
      }

      if (type === "delivery") {
        return `${formatted}FinMeter`;
      }

      if (type === "balance") {
        return `${formatted}BalMeter`;
      }

      return `${formatted}InwMeter`;
    };

    const keyName = getMonthKeyName(selectedCell?.month);


    // ================= GROUP =================
    if (detailTab === "Group") {

      if (type === "delivery") {
        data = GreyInwardDaypartydata?.FinproductionGroup || [];
      }
      else if (type === "balance") {
        data = GreyInwardDaypartydata?.productionGroup || [];
      }
      else {
        data = GreyInwardDaypartydata?.productionGroup || [];
      }

      return data.map((item, index) => ({
        srNumber: index + 1,
        ProductionGroupMstName: item.ProductionGroupMstName,
        InwMeter: item[keyName] || 0,
      }));
    }

    // ================= PARTY =================
    if (detailTab === "Party") {

      if (type === "delivery") {
        data = GreyInwardDaypartydata?.FinParty || [];
      }
      else if (type === "balance") {
        data = GreyInwardDaypartydata?.Party || [];
      }
      else {
        data = GreyInwardDaypartydata?.Party || [];
      }

      return data.map((item, index) => ({
        srNumber: index + 1,
        AcName: item.AcName,
        InwMeter: item[keyName] || 0,
      }));
    }

    // ================= QUALITY =================
    if (detailTab === "Quality") {

      if (type === "delivery") {
        data = GreyInwardDaypartydata?.FinQuality || [];
      }
      else if (type === "balance") {
        data = GreyInwardDaypartydata?.Quality || [];
      }
      else {
        data = GreyInwardDaypartydata?.Quality || [];
      }

      return data.map((item, index) => ({
        srNumber: index + 1,
        ItemName: item.ItemName,
        InwMeter: item[keyName] || 0,
      }));
    }

    return [];

  }, [GreyInwardDaypartydata, detailTab, type, selectedCell]);

  useEffect(() => {
    setShowDetail(false);
    setSelectedCell(null);
    setSelectedDay(null);
    setDetailTab("Group");
    setHoverCell(null);
  }, [view]);

  const handleTypeChange = (newType) => {
    setType(newType);

    // reset selected data
    setSelectedCell(null);
    setSelectedDay(null);
    setShowDetail(false);
    setDetailTab("Group");

  };

  const prevMonth = () => {

    const financialStart = new Date(startYear, startMonth, 1);

    const newDate = new Date(year, month - 1, 1);

    // April 2024 se niche nahi jana
    if (newDate >= financialStart) {
      setCurrentDate(newDate);
    }

    setSelectedDay(null);
  };

  const nextMonth = () => {

    // Financial year ka last month
    const financialEnd = new Date(startYear + 1, startMonth - 1, 1);

    const newDate = new Date(year, month + 1, 1);

    // March 2025 se aage nahi jana
    if (newDate <= financialEnd) {
      setCurrentDate(newDate);
    }

    setSelectedDay(null);
  };

  const goToday = () => {
    setCurrentDate(new Date());
    setSelectedDay(null);
  };

  const handleCellSelect = ({ date, month, value }) => {
    const financialYear = Cookies.get("FinancialYear");

    setSelectedCell({
      date,
      month,
      value,
    });
    dispatch(resetGreyInwardDayparty())
    dispatch(GreyInwardDayparty({
      Firm: selectedFirmId ? selectedFirmId.toString() : "",
      ProductionGroupMstIDs: selectedProductionId ? selectedProductionId.toString() : "",
      FAcYearID: selectedYearId
        ? selectedYearId.toString()
        : financialYear.toString(),
      Day: date ? date : "",
      Month: month ? month : ""
    }))

    setShowDetail(true);
    setDetailTab("Group");

    setTimeout(() => {
      tableRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 100);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setSelectedCell(null);
    setSelectedDay(null);
    setDetailTab("Group");
  };

  const detailLabel =
    type === "inward"
      ? "Inward Meter"
      : type === "delivery"
        ? "Delivery Meter"
        : "Balance Meter";


  const getTopButtonStyle = (buttonType) => ({
    background:
      type === buttonType
        ? isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour1
        : isdark === "light"
          ? iscolour?.Colour7
          : iscolourDark?.Colour6,
    border: "none",
    borderRadius: "12px",
    padding: "14px",
    fontWeight: "700",
    color:
      type === buttonType
        ? isdark === "light"
          ? iscolour?.Colour5
          : iscolourDark?.Colour2
        : isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    transition: "all 0.3s ease",
    boxShadow:
      type === buttonType
        ? "0 6px 18px rgba(0,0,0,0.12)"
        : "0 2px 8px rgba(0,0,0,0.05)",
  });

  const getDetailButtonStyle = (buttonType) => ({
    background:
      detailTab === buttonType
        ? isdark === "light"
          ? iscolour?.Colour1
          : iscolourDark?.Colour1
        : isdark === "light"
          ? iscolour?.Colour7
          : iscolourDark?.Colour6,
    border: "none",
    borderRadius: "14px",
    padding: "14px",
    fontWeight: "600",
    color:
      detailTab === buttonType
        ? isdark === "light"
          ? iscolour?.Colour5
          : iscolourDark?.Colour2
        : isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2,
    transition: "all 0.3s ease",
    boxShadow:
      detailTab === buttonType
        ? "0 6px 18px rgba(0,0,0,0.12)"
        : "0 2px 8px rgba(0,0,0,0.05)",
  });

  const columnTotals = months.reduce((acc, month) => {
    acc[month] = formattedYearData.reduce(
      (sum, row) => sum + (Number(row[month]) || 0),
      0
    );
    return acc;
  }, {});

  // if (GreyInwardDaypartydata === null) {
  //   return (
  //     <div className=" flex justify-center items-center h-screen text-xl " >
  //       <Loader />
  //     </div>
  //   );
  // }


  // if (GreyInwardDaydata === null) {
  //   return (
  //     <div className=" flex justify-center items-center h-screen text-xl " >
  //       <Loader />
  //     </div>
  //   );
  // }

  if (!mainFilterData) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <>
      <style>{`
      .hover-scale-btn {
        transition: transform 0.2s ease-in-out;
        transform: scale(1);
      }

      .hover-scale-btn:hover {
        transform: scale(1.02);
      }
    `}</style>

      <div className="pageContainer">
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour11,
            padding: "15px",
            transition: "all 0.3s ease-in-out",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
          }}
        >
          <Row className="align-items-center justify-Content-center  mb-4 ">

            <Col lg={6} md={6} sm={12} className="text-center text-sm-start ">
              <h4
                className="fw-bold"
                style={{
                  color:
                    isdark === "light"
                      ? iscolour?.Colour2
                      : iscolourDark?.Colour2,
                  transition: "all 0.3s ease-in-out",
                }}
              >
                Daywise Analysis
              </h4>
            </Col>

            <Col lg={6} md={6} sm={12} className="text-center text-sm-end ">
              <div
                className="d-inline-flex"
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour10,
                  padding: "5px",
                  borderRadius: "40px",
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour4
                    : "rgba(149, 213, 178, 0.25)"
                    }`,
                  gap: "5px",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                <Button
                  className="hover-scale-btn"
                  onClick={() => setView("year")}
                  style={{
                    background:
                      view === "year"
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3
                        : "transparent",
                    border: "none",
                    borderRadius: "30px",
                    padding: "8px",
                    color:
                      view === "year"
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour2
                        : isdark === "light"
                          ? iscolour?.Colour12
                          : iscolourDark?.Colour9,
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  Year View
                </Button>

                <Button
                  className="hover-scale-btn"
                  onClick={() => setView("month")}
                  style={{
                    background:
                      view === "month"
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3
                        : "transparent",
                    border: "none",
                    borderRadius: "30px",
                    padding: "8px 18px",
                    color:
                      view === "month"
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour2
                        : isdark === "light"
                          ? iscolour?.Colour12
                          : iscolourDark?.Colour9,
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  Month View
                </Button>
              </div>
            </Col>

          </Row>

          <div className="p-2 p-sm-3 mb-4" style={{
            background:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
            borderRadius: "12px",
            border: `2px solid ${isdark === "light"
              ? iscolour?.Colour4
              : iscolourDark?.Colour3
              }`,
          }}>

            <Row>
              {/* FIRM LIST */}
              <Col lg={4} md={6} sm={12} className="mb-3">
                <DroupdownFilterBox
                  label="FIRM LIST"
                  data={firmOptions}
                  selectedValue={selectedFirm}
                  setSelectedValue={setSelectedFirm}
                  selectedId={selectedFirmId}
                  setSelectedId={setSelectedFirmId}
                  placeholder="Select Firm(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                />
              </Col>

              {/* ACCOUNT YEAR */}
              <Col lg={4} md={6} sm={12} className="mb-3">
                <DroupdownFilterBox
                  label="ACCOUNT YEAR"
                  data={yearOptions}
                  selectedValue={selectedYear}
                  setSelectedValue={setSelectedYear}
                  selectedId={selectedYearId}
                  setSelectedId={setSelectedYearId}
                  placeholder="Select Year(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}
                  isMulti={false}


                />
              </Col>

              {/* PRODUCTION GROUP */}
              <Col lg={4} md={12} sm={12} className="mb-3">
                <DroupdownFilterBox
                  label="PRODUCTION GROUP"
                  data={productionOptions}
                  selectedValue={selectedProduction}
                  setSelectedValue={setSelectedProduction}
                  selectedId={selectedProductionId}
                  setSelectedId={setSelectedProductionId}
                  placeholder="Select Production(s)"
                  isdark={isdark}
                  iscolour={iscolour}
                  iscolourDark={iscolourDark}

                />
              </Col>

              <Col xl={12} className="pt-3" style={{ alignItems: "end", display: "flex" }}  >
                <button
                  onClick={handlesubmit}
                  className="hover-scale-btn"
                  // className="mt-3"
                  style={{
                    padding: " 12px",
                    backgroundColor: "rgb(64, 145, 108)",
                    color: "#fff",
                    width: "100%",
                    border: "1px solid rgb(64, 145, 108)",
                    borderRadius: "10px",
                    // fontSize: "15px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxSizing: "border-box",
                  }}
                >
                  Submit Filters
                </button>
              </Col>
            </Row>
          </div>



          {isFilterApplied && (
            <Row className="mb-4">
              <Col lg={4} md={4} sm={12} className="mb-3 hover-scale-btn">
                <Button
                  className="w-100 hover-scale-btn"
                  onClick={() => handleTypeChange("inward")}
                  style={getTopButtonStyle("inward")}
                >
                  Inward
                </Button>
              </Col>

              <Col lg={4} md={4} sm={12} className="mb-3 hover-scale-btn">
                <Button
                  className="w-100 hover-scale-btn"
                  onClick={() => handleTypeChange("delivery")}
                  style={getTopButtonStyle("delivery")}
                >
                  Delivery
                </Button>
              </Col>

              <Col lg={4} md={4} sm={12} className="mb-3 hover-scale-btn">
                <Button
                  className="w-100 hover-scale-btn"
                  onClick={() => handleTypeChange("balance")}
                  style={getTopButtonStyle("balance")}
                >
                  Balance
                </Button>
              </Col>
            </Row>
          )}


          {isFilterApplied && (
            <div ref={tableRef} >

              {!GreyInwardDaydata ? (
                // 🔄 LOADER
                <div style={{ textAlign: "center", padding: "50px" }}>
                  <Loader />
                </div>
              ) : (
                <>
                  {view === "year" ? (
                    <div
                      className="table-responsive"
                      style={{
                        position: "relative",
                        borderRadius: "10px",
                        overflowX: "auto",
                        overflowY: "auto",
                        maxHeight: "500px", // vertical scroll
                        // transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <Table className="mb-0">
                        <thead>
                          <tr>
                            <th
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 20,
                                padding: "15px",
                                fontSize: "13px",
                                fontWeight: "600",
                                backgroundColor:
                                  isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour3,
                                color: "rgb(255, 255, 255)",
                              }}
                            >
                              DATE
                            </th>

                            {months.map((monthName, index) => (
                              <th
                                key={index}
                                style={{
                                  padding: "15px",
                                  fontSize: "13px",
                                  fontWeight: "600",
                                  textAlign: "center",
                                  backgroundColor:
                                    isdark === "light"
                                      ? iscolour?.Colour1
                                      : iscolourDark?.Colour3,
                                  color: "rgb(255, 255, 255)",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 20,
                                }}
                              >
                                {monthName}
                              </th>
                            ))}
                            <th
                              style={{
                                padding: "15px",
                                fontSize: "13px",
                                fontWeight: "600",
                                textAlign: "center",
                                backgroundColor:
                                  isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour3,
                                color: "#fff",
                                position: "sticky",
                                top: 0,
                                zIndex: 20,
                              }}
                            >
                              TOTAL
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {formattedYearData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              <td
                                style={{
                                  fontWeight: "600",
                                  backgroundColor:
                                    hoverCell?.row === rowIndex
                                      ? isdark === "light"
                                        ? iscolour?.Colour7
                                        : iscolourDark?.Colour3
                                      : rowIndex % 2 === 0
                                        ? isdark === "light"
                                          ? "#f5f5f5"
                                          : iscolourDark?.Colour7
                                        : isdark === "light"
                                          ? "#ffffff"
                                          : iscolourDark?.Colour6,
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour2
                                      : iscolourDark?.Colour2,
                                  transition: "all 0.2s ease-in-out",
                                }}
                              >
                                {row.date}
                              </td>


                              {months.map((monthName, colIndex) => {
                                const isClickable = row[monthName] && Number(row[monthName]) !== 0;

                                return (
                                  <td
                                    key={colIndex}
                                    onClick={() => {
                                      if (isClickable) {
                                        handleCellSelect({
                                          date: row.date,
                                          month: monthName,
                                          value: row[monthName],
                                        });
                                      }
                                    }}
                                    onMouseEnter={() => {
                                      if (isClickable) {
                                        setHoverCell({ row: rowIndex, col: colIndex });
                                      }
                                    }}
                                    onMouseLeave={() => setHoverCell(null)}
                                    style={{
                                      cursor: isClickable ? "pointer" : "default",
                                      textAlign: "center",
                                      backgroundColor:
                                        hoverCell?.row === rowIndex
                                          ? isdark === "light"
                                            ? iscolour?.Colour7
                                            : iscolourDark?.Colour3
                                          : rowIndex % 2 === 0
                                            ? isdark === "light"
                                              ? "#f5f5f5"
                                              : iscolourDark?.Colour7
                                            : isdark === "light"
                                              ? "#ffffff"
                                              : iscolourDark?.Colour6,
                                      transition: "0.2s",
                                    }}
                                  >
                                    <span
                                      style={{
                                        padding: "5px",
                                        borderRadius: "6px",
                                        background:
                                          isClickable &&
                                            (
                                              (hoverCell?.row === rowIndex &&
                                                hoverCell?.col === colIndex) ||
                                              (selectedCell?.date === row.date &&
                                                selectedCell?.month === monthName)
                                            )
                                            ? "#4fa777"
                                            : "transparent",
                                        color:
                                          isClickable &&
                                            (
                                              (hoverCell?.row === rowIndex &&
                                                hoverCell?.col === colIndex) ||
                                              (selectedCell?.date === row.date &&
                                                selectedCell?.month === monthName)
                                            )
                                            ? isdark === "light"
                                              ? iscolour?.Colour5
                                              : iscolourDark?.Colour2
                                            : isdark === "light"
                                              ? iscolour?.Colour2
                                              : iscolourDark?.Colour2,
                                        transition: "0.2s",
                                        display: "inline-block",
                                        minWidth: "100%",
                                        opacity: isClickable ? 1 : 0.5, // 🔥 optional UX (disabled feel)
                                      }}
                                    >
                                      {row[monthName] === 0 || row[monthName] == null
                                        ? ""
                                        : formatIndianNumber(row[monthName])}
                                    </span>
                                  </td>
                                );
                              })}
                              <td
                                style={{
                                  textAlign: "center",
                                  fontWeight: "600",
                                  backgroundColor: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour12,
                                  color: "#fff"

                                }}
                              >
                                <span style={{ padding: "5px" }}>
                                  {(() => {
                                    const total = months.reduce(
                                      (sum, month) => sum + (Number(row[month]) || 0),
                                      0
                                    );
                                    return total === 0 ? "" : formatIndianNumber(total);
                                  })()}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td
                              style={{
                                fontWeight: "700",
                                textAlign: "center",
                                backgroundColor: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour12,
                                color: "#fff",
                                position: "sticky",
                                bottom: 0,
                                zIndex: 20,
                              }}
                            >
                              TOTAL
                            </td>

                            {months.map((month, i) => (
                              <td
                                key={i}
                                style={{
                                  textAlign: "center",
                                  fontWeight: "700",
                                  backgroundColor: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour12,
                                  color: "#fff",
                                  position: "sticky",
                                  bottom: 0,
                                  zIndex: 20,
                                }}
                              >
                                {columnTotals[month] === 0 ? "" : formatIndianNumber(columnTotals[month])}
                              </td>
                            ))}

                            {/* Grand Total */}
                            <td
                              style={{
                                textAlign: "center",
                                fontWeight: "700",
                                backgroundColor: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour12,
                                color: "#fff",
                                position: "sticky",
                                bottom: 0,
                                zIndex: 20,
                              }}
                            >
                              {formatIndianNumber(
                                months.reduce(
                                  (total, month) => total + columnTotals[month],
                                  0
                                )
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  ) : (

                    <>
                      <div
                        style={{
                          border: `1px solid ${isdark === "light"
                            ? iscolour?.Colour8
                            : "rgba(183, 228, 199, 0.15)"
                            }`,
                          borderRadius: "16px",
                          padding: "10px",
                          background: isdark === "light" ? "#fff" : "rgba(255,255,255,0.03)",

                        }}
                      >
                        <div className="" style={{
                          borderRadius: "12px",
                          // background: "#f2f5f3",
                        }}>
                          <Row className="align-items-center mb-3 g-2">

                            {/* TITLE (TOP in mobile) */}
                            <Col xs={12} sm={8} className="text-center order-1 order-sm-2">
                              <h2
                                style={{
                                  fontWeight: "700",
                                  letterSpacing: "1px",
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour1
                                      : iscolourDark?.Colour2,
                                  margin: 0,
                                  fontSize: "18px",
                                }}
                              >
                                {monthNames[month]} {year}
                              </h2>
                            </Col>

                            {/* PREV BUTTON */}
                            <Col xs={6} sm={2} className="order-2 order-sm-1">
                              <Button
                                onClick={prevMonth}
                                style={{
                                  width: "100%",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "6px",
                                  fontSize: "18px",
                                  backgroundColor:
                                    isdark === "light"
                                      ? iscolour?.Colour7
                                      : iscolourDark?.Colour6,
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour1
                                      : iscolourDark?.Colour2,
                                }}
                              >
                                <RiArrowLeftSLine />
                              </Button>
                            </Col>

                            {/* NEXT BUTTON */}
                            <Col xs={6} sm={2} className="text-end order-3">
                              <Button
                                onClick={nextMonth}
                                style={{
                                  width: "100%",
                                  border: "none",
                                  borderRadius: "8px",
                                  padding: "6px",
                                  fontSize: "18px",
                                  backgroundColor:
                                    isdark === "light"
                                      ? iscolour?.Colour7
                                      : iscolourDark?.Colour6,
                                  color:
                                    isdark === "light"
                                      ? iscolour?.Colour1
                                      : iscolourDark?.Colour2,
                                }}
                              >
                                <RiArrowRightSLine />
                              </Button>
                            </Col>

                          </Row>
                        </div>

                        <div
                          style={{
                            background: "#bcd3c1",
                            padding: "12px",
                            borderRadius: "14px",
                            border: `2px solid ${isdark === "light"
                              ? iscolour?.Colour8
                              : iscolourDark?.Colour12
                              }`,
                            overflowX: "auto",
                          }}
                        >
                          <div
                            style={{
                              minWidth: "700px",
                            }}
                          >
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(7, minmax(90px, 1fr))",
                                marginBottom: "10px",
                                fontWeight: "600",
                                textAlign: "center",
                                color: "#2f5e49",
                              }}
                            >
                              {weekDays.map((day, i) => (
                                <div key={i}>{day}</div>
                              ))}
                            </div>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(7, minmax(90px, 1fr))",
                                gap: "10px",
                              }}
                            >
                              {calendarDays.map((d, i) => {

                                const monthShort = monthNames[month].slice(0, 3);

                                const formattedDate = String(d.day).padStart(2, "0");

                                const isSelected =
                                  selectedDay?.date === formattedDate &&
                                  selectedDay?.month === monthShort &&
                                  selectedDay?.value === (d.value || 0);

                                const isClickable =
                                  !d.disabled &&
                                  d.value !== 0 &&
                                  d.value != null;

                                return (
                                  <div
                                    key={i}
                                    onClick={() => {
                                      if (!isClickable) return;

                                      handleCellSelect({
                                        date: formattedDate,
                                        month: monthShort,
                                        value: d.value || 0,
                                      });

                                      setSelectedDay({
                                        date: formattedDate,
                                        month: monthShort,
                                        value: d.value || 0,
                                      });
                                    }}
                                    style={{
                                      background: d.disabled
                                        ? isdark === "light"
                                          ? "rgb(116 198 157 / 30%)"
                                          : "rgba(102, 192, 151, 0.2)"
                                        : isdark === "light"
                                          ? "rgb(116, 198, 157)"
                                          : iscolourDark?.Colour3,

                                      borderRadius: "10px",
                                      height: "80px",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      alignItems: "center",

                                      color: d.disabled ? "#7b9e8b" : "#fff",
                                      fontWeight: "600",
                                      cursor: d.disabled ? "default" : "pointer",

                                      border: isSelected
                                        ? "3px solid #2f6f52"
                                        : "2px solid transparent",

                                      boxShadow: isSelected
                                        ? "0 0 0 2px #d8f1e5 inset"
                                        : "none",

                                      transition: "all 0.25s ease-in-out",
                                    }}
                                  >
                                    <div style={{ fontSize: "14px" }}>
                                      {formattedDate}
                                    </div>

                                    <div style={{ fontSize: "11px" }}>
                                      {d.value === 0 || d.value == null
                                        ? ""
                                        : formatIndianNumber(d.value)}
                                    </div>

                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          )}

          {showDetail && (

            <div ref={tableRef}>

              {!GreyInwardDaypartydata ? (
                // 🔄 LOADER
                <div style={{ textAlign: "center", padding: "50px" }}>

                  <Loader />

                </div>
              ) : (
                <>
                  <Row className="mb-4 pt-4 g-3">

                    {/* 🔷 DETAIL BOX */}
                    <Col xs={12}>
                      <div
                        style={{
                          border: `2px solid ${isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1
                            }`,
                          borderRadius: "12px",
                          background:
                            isdark === "light"
                              ? iscolour?.Colour7
                              : iscolourDark?.Colour6,
                          padding: "16px",

                        }}
                      >
                        <h6
                          style={{
                            fontWeight: "700",
                            marginBottom: "6px",
                            fontSize: "16px",
                            color:
                              isdark === "light"
                                ? iscolour?.Colour2
                                : iscolourDark?.Colour2,
                          }}
                        >
                          Detailed Breakdown
                        </h6>
                        <div className="align-items-center g-3 d-block d-sm-flex flexWrap justify-content-sm-between" >

                          <div
                            className="d-flex flex-wrap"
                            style={{
                              gap: "10px 20px",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {/* DATE */}
                            <div>
                              <b style={{ color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 }}>Date:</b>{" "}
                              <span style={{ color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour2 }}>
                                {selectedCell?.date}
                              </span>
                            </div>

                            {/* MONTH */}
                            <div>
                              <b style={{ color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4 }}>Month:</b>{" "}
                              <span style={{ color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour2 }}>
                                {selectedCell?.month}
                              </span>
                            </div>

                            {/* VALUE */}
                            <div>
                              <b style={{ color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4 }}>
                                {detailLabel}:
                              </b>{" "}
                              <span style={{ color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour2 }}>
                                {formatIndianNumber(selectedCell.value)}
                              </span>
                            </div>
                          </div>

                          <div className="pt-3 pt-sm-0">
                            <Button
                              className="hover-scale-btn w-100 w-lg-auto"
                              size="sm"
                              onClick={handleCloseDetail}
                              style={{
                                borderRadius: "8px",
                                border: `2px solid ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1}`,
                                background: "transparent",
                                padding: "6px 14px",
                                fontWeight: "600",
                                color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1
                              }}
                            >
                              ✕ Close
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Col>

                    {/* 🔷 BUTTONS */}
                    <Col lg={4} md={4} sm={12} >
                      <Button
                        className="w-100 hover-scale-btn"
                        onClick={() => setDetailTab("Group")}
                        style={getDetailButtonStyle("Group")}
                      >
                        GroupWise
                      </Button>
                    </Col>

                    <Col lg={4} md={4} sm={12} >
                      <Button
                        className="w-100 hover-scale-btn"
                        onClick={() => setDetailTab("Party")}
                        style={getDetailButtonStyle("Party")}
                      >
                        PartyWise
                      </Button>
                    </Col>

                    <Col lg={4} md={4} sm={12} >
                      <Button
                        className="w-100 hover-scale-btn"
                        onClick={() => setDetailTab("Quality")}
                        style={getDetailButtonStyle("Quality")}
                      >
                        QualityWise
                      </Button>
                    </Col>

                  </Row>

                  {/* 🔷 TABLE */}
                  <Row className="mt-3">
                    <Col >
                      <div
                        style={{
                          borderRadius: "12px",
                          overflow: "hidden",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor:
                              isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour1,
                            color:
                              isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour8,
                            padding: "14px",
                          }}
                        >
                          <h2
                            style={{
                              fontSize: "18px",
                              margin: 0,
                              letterSpacing: "1px",
                              fontWidth:"700"

                            }}
                          >
                            {detailTab?.toUpperCase()}WISE DATA
                          </h2>
                        </div>
                        <div >
                          <GreyTable columns={detailColumns} data={formattedDetailData} iscolourDark={iscolourDark}
                            iscolour={iscolour} />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </div>
          )}
        </div>
      </div >
    </>
  );
};

export default Daywise;
